import { StaticModal, createModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import { useApplySimulationMutation, useSimulationId } from '../hooks';
import { useCustomTranslation } from '../../../../../hooks/useCustomTranslation';
import { SimulationLotSummary } from './SimulationEditModal/components/SimulationLot';

export const SummaryModal = () => {
  const applySimulation = useApplySimulationMutation();
  const { id } = useSimulationId();
  const { tWrapper } = useCustomTranslation('products.simulationPlan');

  const handleApplySimulation = async () => {
    await applySimulation.mutateAsync(id);
    closeSummaryModal();
  };

  return (
    <StaticModal component="form" maxWidth="lg" onClose={closeSummaryModal}>
      <StaticModal.Header withCloseButton>{tWrapper('summaryModalTitle')}</StaticModal.Header>
      <StaticModal.Content className="flex flex-col gap-6 pb-0">
        <div className="text-s18">{tWrapper('summaryModalEditInfo')}</div>
        <SimulationLotSummary />
        <div className="text-s18">{tWrapper('summaryModalRedirectInfo')}</div>
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button variant="outlined" onClick={closeSummaryModal}>
          {tWrapper('simulationCancel')}
        </Button>
        <Button isLoading={applySimulation.isPending} variant="contained" onClick={handleApplySimulation}>
          {tWrapper('summaryModalConfirm')}
        </Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { openSummaryModal, closeSummaryModal } = createModal(SummaryModal, {
  name: 'SummaryModal',
});
